import axios from 'axios';

import processing_activities_messages from 'messages/processing_activities_messages';

type ArchiveConfirmMessage = typeof processing_activities_messages.archive_confirm.error;

const getConflictCode = (data: unknown): string | undefined => {
  if (!data || typeof data !== 'object' || !('code' in data)) {
    return undefined;
  }

  const { code } = data as { code: unknown };
  return typeof code === 'string' ? code : undefined;
};

const getProcessingActivityArchiveErrorMessage = (error: unknown): ArchiveConfirmMessage => {
  if (!axios.isAxiosError(error)) {
    return processing_activities_messages.archive_confirm.error;
  }

  if (error.response?.status === 403) {
    return processing_activities_messages.archive_confirm.forbidden;
  }

  const code = getConflictCode(error.response?.data);

  if (code === 'already_archived') {
    return processing_activities_messages.archive_confirm.already_archived;
  }

  if (code === 'never_published_activity' || code === 'not_published') {
    return processing_activities_messages.archive_confirm.never_published;
  }

  if (code === 'active_review_round') {
    return processing_activities_messages.archive_confirm.active_review;
  }

  return processing_activities_messages.archive_confirm.error;
};

export default getProcessingActivityArchiveErrorMessage;
